// import React, { useState, useMemo, useEffect, useCallback } from "react";
// import { Apartment } from "../../hook/types/apartment";
// import ApartmentPopup from "../Popups/ApartmentPopup";
// import Dropdown from "../Common/Dropdown/main";
// import SearchBar from "../Common/SearchBar/main";
// import { Popup } from "../Common/Popup/main";
// import DeletePopup from "../Popups/deletePopup";

// import { useApartment } from "../../hook/useApartment";
// import ApartmentList from "./main";

// import { FaSpinner } from "react-icons/fa";
// import EditApartmentPopup from "./EditApartmentPopup";

// const ApartmentCard: React.FC = () => {
//   const {
//     addApartment,
//     Apartment: useApartmentQuery, // Rename to avoid conflict
//     deleteApartment,
//     updateApartment,
//     queryClient
//   } = useApartment();
  
//   const [isActive, setIsActive] = useState<boolean | null>(true);
//   const [isDelete, setIsDelete] = useState<boolean>(false);
//   const [openPopup, setOpenPopup] = useState(false);
//   const [DeletPopup, setDeletPopup] = useState(false);
//   const [activeId, setActiveId] = useState("");
//   const [addApartmentStatus, setAddApartment] = useState(false);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [selectedApartment, setSelectedApartment] = useState<Apartment>({
//     isActive: true,
//     apartmentName: "",
//     apartmentAddress: "",
//     apartmentImageUrl: "",
//     propertyHoldings: [],
//     appartmentType: "",
//   });

//   const [statusDropdownOpen, setStatusDropdownOpen] = useState(false);
//   const [filterType, setFilterType] = useState<"Active" | "Inactive" | "Deleted">("Active");

//   // Use the query hook with stable parameters
//   const Apartments = useApartmentQuery({ 
//     active: isActive, 
//     delete: isDelete, 
//     // page: 0, 
//     // size: 100 
//   });

//   // Fix useEffect dependencies
//   useEffect(() => {
//     if (filterType === "Active") {
//       setIsActive(true);
//       setIsDelete(false);
//     } else if (filterType === "Inactive") {
//       setIsActive(false);
//       setIsDelete(false);
//     } else if (filterType === "Deleted") {
//       setIsActive(null);
//       setIsDelete(true);
//     }
//   }, [filterType]); // Add filterType to dependencies

// const filteredApartments = useMemo(() => {
//   if (Apartments.isSuccess && Apartments.data?.data?.content) {
//     return Apartments.data.data.content.filter((apartment: Apartment) => {
//       // Check both possible property names for apartment name
//       const apartmentName = apartment.apartmentName || apartment.apartmentName || '';
//       return apartmentName.toLowerCase().includes(searchQuery.toLowerCase());
//     });
//   }
//   return [];
// }, [Apartments.isSuccess, Apartments.data, searchQuery]);

//   // Use useCallback for stable function references
// // In the main ApartmentCard component
// const handleEdit = useCallback(async (apartment: Apartment, Id: string | number) => {
//   // console.log("Edit clicked for apartment:", apartment, "ID:", Id);
//   setAddApartment(false);
//   setSelectedApartment(apartment);
//   setActiveId(Id.toString());
//   setOpenPopup(true); // This should open the edit popup
// }, []);

// const handleDelete = useCallback(async (id?: string | number) => {
//   // console.log("Delete clicked, ID:", id);
//   if (id !== undefined) {
//     setActiveId(id.toString());
//     setDeletPopup(true);
//   }
// }, []);

// const handleConfirmDelete = useCallback(async () => {
// //  console.log("Confirm delete called, activeId:", activeId);
//   try {
//     await deleteApartment.mutateAsync(activeId, {
//       onSuccess: () => {
//       //  console.log("Delete successful");
//         queryClient.invalidateQueries({ queryKey: ["apartments"] });
//         setDeletPopup(false);
//       },
//       onError: (error) => {
//         console.error("Delete error:", error);
//       }
//     });
//   } catch (error) {
//     console.error("Error in delete mutation:", error);
//   }
// }, [activeId, deleteApartment, queryClient]);




//   const handleSubmit = useCallback(async (formData: Apartment) => {
// //  console.log("Form submitted:", formData);
  
//   try {
//     if (addApartmentStatus) {
//   //    console.log("Adding new apartment");
//       await addApartment.mutateAsync({
//         isActive: formData.isActive,
//         apartmentName: formData.apartmentName,
//         apartmentAddress: formData.apartmentAddress,
//         propertyHoldings: formData.propertyHoldings,
//         apartmentImageUrl: formData.apartmentImageUrl,
//         apartmentImage: formData.apartmentImage,
//         appartmentType: formData.appartmentType,

//         // If you need to pass the image file, you'll need to handle it differently
//       });
//     } else {
//      // console.log("Updating apartment:", activeId);
//       await updateApartment.mutateAsync(
//         { 
//           apartmentId: activeId, 
//           updatedApartment: {
//             ...formData,
//             apartmentImage: formData.apartmentImage // Pass the image file
//           }
//         },
//         {
//           onSuccess: () => {
//             queryClient.invalidateQueries({ queryKey: ["apartments"] });
//           },
//         }
//       );
//     }
//     setOpenPopup(false);
//     setAddApartment(false);
//   } catch (error) {
//     console.error("Error occurred during apartment mutation:", error);
//   }
// }, [addApartmentStatus, activeId, addApartment, updateApartment, queryClient]);

//   const handleCancel = useCallback(() => {
//     setOpenPopup(false);
//   }, []);



//   return (
//     <div className="h-screen flex w-full flex-col">
//       <header className="sticky top-0 backdrop-blur-md bg-background shadow z-10">
//         <h1 className="text-2xl text-start font-bold px-5 py-2 text-foreground">
//           Apartments
//         </h1>
//         <div className="py-4 px-5 flex flex-col w-full items-center justify-between">
//           <div className="flex flex-col sm:flex-row w-full items-center justify-between gap-4">
//             <div onClick={() => setStatusDropdownOpen(!statusDropdownOpen)}>
//               <Dropdown
//                 options={["Active", "Inactive", "Deleted"]}
//                 className="w-full sm:w-60"
//                 className2="py-3 text-sm"
//                 onSelect={(e) => {
//                   setFilterType(e as "Active" | "Inactive" | "Deleted");
//                   setStatusDropdownOpen(false);
//                 }}
//                 activeOption={filterType}
//                 isOpen={statusDropdownOpen}
//                 setIsOpen={setStatusDropdownOpen}
//                 closeOtherDropdown={() => {}}
//               />
//             </div>
//             <div className="w-full sm:w-auto">
//               <SearchBar 
//                 onClear={() => setSearchQuery("")} 
//                 onSearch={(query) => setSearchQuery(query)} 
//               />
//             </div>
//             <button
//             className="bg-primary justify-center gap-1 text-white flex hover:bg-secondary rounded-lg px-4 py-2 text-sm w-full sm:w-auto"
//               onClick={() => {
//                 setSelectedApartment({
//                   isActive: true,
//                   apartmentName: "",
//                   apartmentAddress: "",
//                   apartmentImageUrl: "",
//                   appartmentType: "",
//                   propertyHoldings: [],
//                 });
//                 setAddApartment(true);
//                 setOpenPopup(true);
//               }}
//             >
//               Add
//               <span className="lg:hidden sm:block md:block xl:block">
//                 New
//               </span>
//             </button>
//           </div>
//         </div>
//       </header>

//       {Apartments.isLoading ? (
//         <div className="h-full w-full justify-center flex items-center">
//           <p className="flex gap-1 justify-center text-foreground items-center">
//             <FaSpinner className="animate-spin mr-2" /> Loading...
//           </p>
//         </div>
//       ) : (
//         <div className="min-w-full flex gap-2 flex-col p-4">
//           <p className="text-base font-semibold py-1 w-full border-b border-border">
//             All Apartments
//           </p>
//           {filteredApartments.length === 0 ? (
//             <p className="text-center text-muted-foreground py-8">No apartments found</p>
//           ) : (

// <ApartmentList
//   apartments={filteredApartments}
//   onEdit={handleEdit}
//   onDelete={handleDelete} 
// />
//           )}
//         </div>
//       )}

// {openPopup && (
//   <Popup
//     className="lg:top-5"
//     closeButton={true}
//     onClose={handleCancel}
//   >
//     {addApartmentStatus ? (
//       <EditApartmentPopup
//         apartment={selectedApartment}
//         onClose={handleCancel}
//         onSubmit={handleSubmit}
//         onCancel={handleCancel}
//         isOpen={openPopup}
//       id={activeId}
//         isLoading={updateApartment.isPending || addApartment.isPending}
//       />
//     ) : (
//    <EditApartmentPopup
//         apartment={selectedApartment}
//         onClose={handleCancel}
//         onSubmit={handleSubmit}
//         onCancel={handleCancel}
//         isOpen={openPopup}
//         id={activeId}
//         isLoading={updateApartment.isPending}
//       />
//     )}
//   </Popup>
// )}
      
//      {DeletPopup && (
//   <Popup
//     children={
//       <DeletePopup
//         isLoading={deleteApartment.isPending}
//         isOpen={DeletPopup}
//         onClose={() => setDeletPopup(false)}
//         // onDelete={() => handleDelete(activeId)}
//         onDelete={handleConfirmDelete}
//       />
//     }
//     onClose={() => setDeletPopup(false)}
//   />
// )}
       
    
//     </div>
//   );
// };

// export default ApartmentCard;

import React, { useState, useMemo, useEffect, useCallback } from "react";
import { Apartment } from "../../hook/types/apartment";
import ApartmentPopup from "../Popups/ApartmentPopup";
import Dropdown from "../Common/Dropdown/main";
import SearchBar from "../Common/SearchBar/main";
import { Popup } from "../Common/Popup/main";
import DeletePopup from "../Popups/deletePopup";

import { useApartment } from "../../hook/useApartment";
import ApartmentList from "./main";

import { FaSpinner } from "react-icons/fa";
import EditApartmentPopup from "./EditApartmentPopup";

const ApartmentCard: React.FC = () => {
  const {
    addApartment,
    Apartment: useApartmentQuery,
    deleteApartment,
    updateApartment,
    queryClient
  } = useApartment();
  
  const [isActive, setIsActive] = useState<boolean | null>(true);
  const [isDelete, setIsDelete] = useState<boolean>(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [DeletPopup, setDeletPopup] = useState(false);
  const [activeId, setActiveId] = useState("");
  const [addApartmentStatus, setAddApartment] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedApartment, setSelectedApartment] = useState<Apartment>({
    isActive: true,
    apartmentName: "",
    apartmentAddress: "",
    apartmentImageUrl: "",
    propertyHoldings: [],
    appartmentType: "",
  });

  const [statusDropdownOpen, setStatusDropdownOpen] = useState(false);
  const [filterType, setFilterType] = useState<"Active" | "Inactive" | "Deleted">("Active");

  // Use the query hook with stable parameters
  const Apartments = useApartmentQuery({ 
    active: isActive, 
    delete: isDelete, 
  });

  // Fix useEffect dependencies
  useEffect(() => {
    if (filterType === "Active") {
      setIsActive(true);
      setIsDelete(false);
    } else if (filterType === "Inactive") {
      setIsActive(false);
      setIsDelete(false);
    } else if (filterType === "Deleted") {
      setIsActive(null);
      setIsDelete(true);
    }
  }, [filterType]);

  // Separate apartments by type
  const { commercialApartments, residentialApartments } = useMemo(() => {
    if (Apartments.isSuccess && Apartments.data?.data?.content) {
      const allApartments = Apartments.data.data.content.filter((apartment: Apartment) => {
        const apartmentName = apartment.apartmentName || '';
        return apartmentName.toLowerCase().includes(searchQuery.toLowerCase());
      });

      // Separate by apartment type with proper type annotations
      const commercial = allApartments.filter((apartment: Apartment) => 
        apartment.appartmentType === "COMMERCIAL" || apartment.appartmentType === "Commercial"
      );
      
      const residential = allApartments.filter((apartment: Apartment) => 
        apartment.appartmentType === "RESIDENTIAL" || apartment.appartmentType === "Residential"
      );

      return {
        commercialApartments: commercial,
        residentialApartments: residential
      };
    }

    return {
      commercialApartments: [],
      residentialApartments: []
    };
  }, [Apartments.isSuccess, Apartments.data, searchQuery]);

  // Use useCallback for stable function references
  const handleEdit = useCallback(async (apartment: Apartment, Id: string | number) => {
    setAddApartment(false);
    setSelectedApartment(apartment);
    setActiveId(Id.toString());
    setOpenPopup(true);
  }, []);

  const handleDelete = useCallback(async (id?: string | number) => {
    if (id !== undefined) {
      setActiveId(id.toString());
      setDeletPopup(true);
    }
  }, []);

  const handleConfirmDelete = useCallback(async () => {
    try {
      await deleteApartment.mutateAsync(activeId, {
        onSuccess: () => {
          queryClient.invalidateQueries({ queryKey: ["apartments"] });
          setDeletPopup(false);
        },
        onError: (error) => {
          console.error("Delete error:", error);
        }
      });
    } catch (error) {
      console.error("Error in delete mutation:", error);
    }
  }, [activeId, deleteApartment, queryClient]);

  const handleSubmit = useCallback(async (formData: Apartment) => {
    try {
      if (addApartmentStatus) {
        await addApartment.mutateAsync({
          isActive: formData.isActive,
          apartmentName: formData.apartmentName,
          apartmentAddress: formData.apartmentAddress,
          propertyHoldings: formData.propertyHoldings,
          apartmentImageUrl: formData.apartmentImageUrl,
          apartmentImage: formData.apartmentImage,
          appartmentType: formData.appartmentType,
        });
      } else {
        await updateApartment.mutateAsync(
          { 
            apartmentId: activeId, 
            updatedApartment: {
              ...formData,
              apartmentImage: formData.apartmentImage
            }
          },
          {
            onSuccess: () => {
              queryClient.invalidateQueries({ queryKey: ["apartments"] });
            },
          }
        );
      }
      setOpenPopup(false);
      setAddApartment(false);
    } catch (error) {
      console.error("Error occurred during apartment mutation:", error);
    }
  }, [addApartmentStatus, activeId, addApartment, updateApartment, queryClient]);

  const handleCancel = useCallback(() => {
    setOpenPopup(false);
  }, []);

  return (
    <div className="h-screen flex w-full flex-col">
      <header className="sticky top-0 backdrop-blur-lg bg-background shadow z-10">
        <h1 className="text-2xl text-start font-bold px-5 py-2 text-foreground">
          Apartments
        </h1>
        <div className="py-4 px-5 flex flex-col w-full items-center justify-between">
          <div className="flex flex-col sm:flex-row w-full items-center justify-between gap-4">
            <div onClick={() => setStatusDropdownOpen(!statusDropdownOpen)}>
              <Dropdown
                options={["Active", "Inactive", "Deleted"]}
                className="w-full sm:w-60"
                className2="py-3 text-sm"
                onSelect={(e) => {
                  setFilterType(e as "Active" | "Inactive" | "Deleted");
                  setStatusDropdownOpen(false);
                }}
                activeOption={filterType}
                isOpen={statusDropdownOpen}
                setIsOpen={setStatusDropdownOpen}
                closeOtherDropdown={() => {}}
              />
            </div>
            {/* <div className="w-full sm:w-auto">
              <SearchBar 
                onClear={() => setSearchQuery("")} 
                onSearch={(query) => setSearchQuery(query)} 
              />
            </div> */}
              <div className="w-full sm:w-auto">
              <SearchBar
                suggestionInputEnable={{
                  setActiveValue: (value: string) => {
                    setSearchQuery(value);
                  },
                  activeValue: searchQuery,
                  enable: true,
                  loading: Apartments.isLoading,
                  onSuggestionSelect: (index: number) => {
                    // Get all apartment names from both commercial and residential
                    const allApartmentNames = [
                      ...commercialApartments.map((apartment: any) => apartment.apartmentName),
                      ...residentialApartments.map((apartment: any) => apartment.apartmentName)
                    ];
                    if (allApartmentNames[index]) {
                      setSearchQuery(allApartmentNames[index]);
                    }
                  },
                  suggestions: [
                    ...commercialApartments.map((apartment: any) => apartment.apartmentName),
                    ...residentialApartments.map((apartment: any) => apartment.apartmentName)
                  ],
                }}
                onClear={() => {
                  setSearchQuery("");
                }}
                onSearch={(query) => setSearchQuery(query)}
              />
            </div>
            <button
              className="bg-primary justify-center gap-1 text-white flex hover:bg-secondary rounded-lg px-4 py-2 text-sm w-full sm:w-auto"
              onClick={() => {
                setSelectedApartment({
                  isActive: true,
                  apartmentName: "",
                  apartmentAddress: "",
                  apartmentImageUrl: "",
                  appartmentType: "",
                  propertyHoldings: [],
                });
                setAddApartment(true);
                setOpenPopup(true);
              }}
            >
              Add
              <span className="lg:hidden sm:block md:block xl:block">
                New
              </span>
            </button>
          </div>
        </div>
      </header>

      {Apartments.isLoading ? (
        <div className="h-full w-full justify-center flex items-center">
          <p className="flex gap-1 justify-center text-foreground items-center">
            <FaSpinner className="animate-spin mr-2" /> Loading...
          </p>
        </div>
      ) : (
        <div>
          {/* Commercial Apartments Section */}
          {commercialApartments.length > 0 && (
            <div className="min-w-full flex gap-2 flex-col p-4">
              <p className="text-base font-semibold py-1 w-full border-b border-border">
                Commercial Apartments
              </p>
              <ApartmentList
                apartments={commercialApartments}
                onEdit={handleEdit}
                onDelete={handleDelete} 
              />
            </div>
          )}

          {/* Residential Apartments Section */}
          {residentialApartments.length > 0 && (
            <div className="min-w-full flex gap-2 flex-col p-4">
              <p className="text-base font-semibold py-1 w-full border-b border-border">
                Residential Apartments
              </p>
              <ApartmentList
                apartments={residentialApartments}
                onEdit={handleEdit}
                onDelete={handleDelete} 
              />
            </div>
          )}

          {/* Show message if no apartments found */}
          {commercialApartments.length === 0 && residentialApartments.length === 0 && (
            <div className="min-w-full flex gap-2 flex-col p-4">
              <p className="text-center text-muted-foreground py-8">No apartments found</p>
            </div>
          )}
        </div>
      )}

      {/* {openPopup && (
        <Popup
          className="lg:top-5"
          closeButton={true}
          onClose={handleCancel}
          
        >
          {addApartmentStatus ? (
            <EditApartmentPopup
              apartment={selectedApartment}
              onClose={handleCancel}
              onSubmit={handleSubmit}
              onCancel={handleCancel}
              isOpen={openPopup}
              id={activeId}
              isLoading={updateApartment.isPending || addApartment.isPending}
            />
          ) : (
            <EditApartmentPopup
              apartment={selectedApartment}
              onClose={handleCancel}
              onSubmit={handleSubmit}
              onCancel={handleCancel}
              isOpen={openPopup}
              id={activeId}
              isLoading={updateApartment.isPending}
            />
          )}
        </Popup>
      )} */}
      
      {openPopup && (
  <EditApartmentPopup
    apartment={selectedApartment}
    onClose={handleCancel}
    onSubmit={handleSubmit}
    onCancel={handleCancel}
    isOpen={openPopup}
    id={activeId}
    isLoading={addApartmentStatus ? addApartment.isPending : updateApartment.isPending}
  />
)}

      {DeletPopup && (
        <Popup
          children={
            <DeletePopup
              isLoading={deleteApartment.isPending}
              isOpen={DeletPopup}
              onClose={() => setDeletPopup(false)}
              onDelete={handleConfirmDelete}
            />
          }
          onClose={() => setDeletPopup(false)}
        />
      )}
    </div>
  );
};

export default ApartmentCard;